import script from "./ProductSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductSelect.vue?vue&type=script&lang=ts&setup=true"

import "./ProductSelect.vue?vue&type=style&index=0&id=45380810&lang=scss"

const __exports__ = script;

export default __exports__